import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowRight from "@mui/icons-material/ArrowForward";
import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getHomeLoanRates } from "../../Services/loanService";

// Sample data for loanSlides


const LoanBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [animateIn, setAnimateIn] = useState(false); // Animation state
  const [loanData, setLoanData] = useState([]); // State to store loan data
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 600; // Simple check for mobile devices
  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % loanSlides.length);
      }, 3000); // Change slide every 3 seconds

      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [isAutoPlaying]);

  const prevSlide = () => {
    setCurrentSlide((prevIndex) =>
      prevIndex === 0 ? loanSlides.length - 1 : prevIndex - 1,
    );
  };

  const nextSlide = () => {
    setCurrentSlide((prevIndex) => (prevIndex + 1) % loanSlides.length);
  };

  
  useEffect(() => {
    fetchLoanRates(); // Fetch loan rates when the component mounts
  }, []);

  const fetchLoanRates = async () => {
    try {
      const rates = await getHomeLoanRates(); // Get data from the API
      setLoanData(rates); // Set loan data state
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      console.error("Error fetching loan rates:", error);
      setLoading(false); // Set loading to false even if there is an error
    }
  };
  // console.log("loan data in banner=====>", loanData);


  const loanSlides = [
  {
    id: 1,
    bank: loanData[0]?.bank_name || "Bank A", // Use bank name from API data or fallback to "Bank A"
    offer: "Special Offer",
    tagline: "Low-Interest Loans with Flexible Tenure - Apply Now!",
    highlight: loanData[0]?.min_roi ? `${loanData[0].min_roi}% ` : " p.a.", // Use min_roi from API data or fallback to "8.50% p.a."
    subtext: loanData[0]?.loan_amount ? `Up to Rs. ${loanData[0].loan_amount} loan amount` : "Up to Rs. 5 Cr loan amount",
    gradient: "linear-gradient(to right, #cb1111, #fcb7b7)", // Corrected gradient syntax
    icon: ChevronRight,
  },
  {
    id: 2,
    bank: loanData[1]?.bank_name || "Bank B", // Use bank name from API data or fallback to "Bank B"
    offer: "Home Loan Offer",
    tagline: "Home Loans with Easy Approval!",
    highlight: loanData[1]?.min_roi ? `${loanData[1].min_roi}% ` : " p.a.",
    subtext: loanData[1]?.loan_amount ? `Up to Rs. ${loanData[1].loan_amount} loan amount` : "Up to Rs. 3 Cr loan amount",
    gradient: "linear-gradient(to right, #860e68, #e59cc1)", // Corrected gradient syntax
    icon: ChevronRight,
  },
  {
    id: 3,
    bank: loanData[2]?.bank_name || "Bank C", // Use bank name from API data or fallback to "Bank C"
    offer: "Education Loan",
    tagline: "Low-Interest Loans with Flexible Tenure - Apply Now!",
    highlight: loanData[2]?.min_roi ? `${loanData[2].min_roi}% ` : " p.a.",
    subtext: loanData[2]?.loan_amount ? `Up to Rs. ${loanData[2].loan_amount} loan amount` : "Up to Rs. 2 Cr loan amount",
    gradient: "linear-gradient(to right, #142a74, #91a3df)", // Corrected gradient syntax
    icon: ChevronRight,
  },
  {
    id: 4,
    bank: loanData[3]?.bank_name || "Bank D",
    offer: "Personal Loans for All",
    tagline: "Quick Approval Personal Loans!",
    highlight: loanData[3]?.min_roi ? `${loanData[3].min_roi}% ` : " p.a.",
    subtext: loanData[3]?.loan_amount ? `Up to Rs. ${loanData[3].loan_amount} loan amount` : "Up to Rs. 1 Cr loan amount",
    gradient: "linear-gradient(to right, #f57c00, #fdd2a7)", // Corrected gradient syntax
    icon: ChevronRight,
  },
];

  return (
    <Box
      sx={{
        position: "relative",
        marginBottom: 6,
        borderRadius: 2,
        overflow: "hidden",
        "&:hover": {
          cursor: "pointer",
        },
      }}
      onMouseEnter={() => setIsAutoPlaying(false)}
      onMouseLeave={() => setIsAutoPlaying(true)}
    >
      {/* Main Carousel */}
      <Box sx={{ height: 270, width: "100%" }}>
        {loanSlides.map((slide, index) => (
          <Box
            key={slide.id}
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              
              alignItems: "center",
              justifyContent: "space-between",
              padding: isMobile ? 1 : 6,
              transition: "all 0.5s ease-in-out",
              background: slide.gradient,
              transform:
                index === currentSlide
                  ? "translateX(0)"
                  : index < currentSlide
                    ? "-translateX(100%)"
                    : "translateX(100%)",
              opacity: index === currentSlide ? 1 : 0,
              zIndex: index === currentSlide ? 1 : 0,
            }}
          >
            {/* Left Content */}
            <Box sx={{ flex: 1, maxWidth: isMobile ? "100%" : "60%" }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    padding: "3px 12px",
                    borderRadius: "16px",
                    fontSize: isMobile ? "14px" : "12px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  {slide.bank}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    padding: "3px 12px",
                    borderRadius: "16px",
                    fontSize: isMobile ? "14px" : "12px",
                    fontWeight: "600",
                    color: "white",
                  }}
                >
                  {slide.offer}
                </Typography>
              </Box>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: isMobile ? "16px" : "24px",
                  marginTop: 2,
                  lineHeight: 1.4,
                }}
              >
                {slide.tagline}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                  gap: 1,
                  marginTop: 1,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ color: "white", fontWeight: "bold",fontSize: isMobile ? "14px" : "14px", }}
                >
                  {slide.highlight}
                </Typography>
                <Typography
                  variant={"body2"}
                  sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: isMobile ? "10px" : "none" }}
                >
                  {slide.subtext}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                position: "absolute",
                top: "-10%",
                right: "-10%",
                width: isMobile ? 80 : 160,
                height: isMobile ? 80 : 160,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.05)",

                backdropFilter: "blur(15px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: "-12%",
                left: "-4%",
                width: isMobile ? 40 : 80,
                height:  isMobile ? 40 : 80,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
              }}
            />

            {/* Right Content - Icon */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Box
                sx={{
                  width: isMobile ? 40 : 80,
                  height:  isMobile ? 40 : 80,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backdropFilter: "blur(15px)",
                }}
              >
                {/* <slide.icon sx={{ color: 'white', fontSize: '40px' }} /> */}
              </Box>
              <Button
                variant="contained"
                onClick={() => navigate("/Home/LoanAssist")}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  color: "white",
                  padding: "8px 12px",
                  fontWeight: "600",
                  boxShadow: 3,
                  fontSize: "12px",
                  fontFamily: "Inter-Medium",
                  textTransform: "none",
                  transition: "all 0.3s",
                  marginRight: isMobile ? 6 : 0,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                  },
                }}
              >
                Explore Loan Offers
                <ArrowRight sx={{ marginLeft: 1, fontSize: 20 }} />
              </Button>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Navigation Arrows */}
      <IconButton
        onClick={prevSlide}
        sx={{
          position: "absolute",
          top: "50%",
          left: 3,
          transform: "translateY(-50%)",
          zIndex: 2,
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          color: "white",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          },
        }}
        aria-label="Previous slide"
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        onClick={nextSlide}
        sx={{
          position: "absolute",
          top: "50%",
          right: 3,
          transform: "translateY(-50%)",
          zIndex: 2,
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          color: "white",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          },
        }}
        aria-label="Next slide"
      >
        <ChevronRightIcon />
      </IconButton>

      {/* Slide Indicators */}
      <Box
        sx={{
          position: "absolute",
          bottom: 3,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1,
        }}
      >
        {loanSlides.map((_, index) => (
          <IconButton
            key={index}
            onClick={() => setCurrentSlide(index)}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor:
                index === currentSlide ? "white" : "rgba(255, 255, 255, 0.5)",
              transition: "all 0.3s",
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LoanBanner;
